import Dropdown from "../../../shared/components/Dropdown";
import { useState, useEffect, useMemo } from "react";
import ActionService, { ActionType } from "../../../../services/ActionService";
import { TranslationService } from "../../../../services/TranslationService";
import { getEnumArray } from "../../../../utils/EnumUtils";
import { endpointRequest } from "../../../../utils/RequestUtils";
import { Field } from "./FieldHelpers";
import { EditProps, strEvent } from "../EditAction";
import { ValidationMessage } from "../../../shared/RequieredManager";
import CompanyService from "../../../../services/CompanyService";

export const Title = ({ data, setField, propGen: props }: EditProps) => {
  const items = useMemo(() => {
    const itemsFilter = getEnumArray(ActionType).filter(
      (el) => el.key !== ActionType.Multiple
    );
    if (
      !(CompanyService.canDo("newwhatsapp") && CompanyService.canShowWhatsApp())
    ) {
      return itemsFilter.filter(
        (el) => el.value !== ActionType.ActionSendWhatsApp
      );
    }
    return itemsFilter;
  }, []);
  enum ActionOptionTypes {
    Custom,
    NewInvoiceNotification
  }
  const showOptionTypes = data.Type === ActionType.MailSend;
  // const selectedOptionType = OptionalMap(data.when, x => Math.max(x, 0));
  const [folders, setFolders] = useState<{ value: number; text: string }[]>();
  useEffect(() => {
    endpointRequest(ActionService.list, (x) => {
      setFolders(
        x.list
          .map((y) => ({ value: y.id, text: y.name! }))
          .filter((y) => y.text?.length)
      );
    });
  }, []);

  const nameProps = props.str.required("Name");
  const actionProps = props.num.required("Type");

  const whenProps = props.num.required("When");
  const WhenProps = props.num.required("when");

  const onChangePropWhen = (x) => {
    whenProps.onChange(x);
    WhenProps.onChange(x);
  };
  const validateShowEmailTypes =
    showOptionTypes &&
    ((data?.When !== 0 && data?.When !== 1) ||
      (data?.when !== 0 && data?.when !== 1));
  return (
    <>
      <div className="row">
        <Field title={TranslationService.translate.Description}>
          <input
            className="form-control"
            {...strEvent(nameProps)}
            maxLength={50}
          />
          <ValidationMessage
            {...nameProps}
            message={TranslationService.translate.EnterName}
          />
        </Field>
        {folders ? (
          <Field title={TranslationService.translate.Folder}>
            <Dropdown
              optionLabel={TranslationService.translate.None}
              onChange={setField("ActionFolderID")}
              value={data.ActionFolderID}
              items={folders.slice()}
            />
          </Field>
        ) : (
          <Field title={TranslationService.translate.Folder}>
            <Dropdown
              optionLabel={TranslationService.translate.None}
              onChange={setField("ActionFolderID")}
              items={[]}
            />
          </Field>
        )}
      </div>
      <div className="row">
        <Field title={TranslationService.translate.Action}>
          <Dropdown
            optionLabel={TranslationService.translate.Select}
            {...actionProps}
            items={items}
          />
          <ValidationMessage
            {...actionProps}
            message={TranslationService.translate.EnterType}
          />
        </Field>
        {showOptionTypes && (
          <Field title={TranslationService.translate.Type}>
            <Dropdown
              items={getEnumArray(ActionOptionTypes).reverse()}
              optionLabel={TranslationService.translate.Select}
              onChange={onChangePropWhen}
              defaultValue={data?.When || data?.when}
            />
            {validateShowEmailTypes && (
              <p className={"text-danger"}>
                {TranslationService.translate.EnterType}
              </p>
            )}
          </Field>
        )}
      </div>
    </>
  );
};
